import UIfx from 'uifx';

import attentionSound from '@vlabs/shared/assets/media/attention.mp3';

export const playAttentionSound = () => new UIfx(attentionSound).play();
